<!--
 * @Description: 缺陷清单
-->
<template>
  <div>
    <CockpitDialog
      title="应急管理"
      class="absolute left-90px top-285px w-1000px h-475px text-white !text-opacity-80 transition-all duration-300 ease-in-out"
      :style="{ left: collapsePanel ? '-1000px' : '90px' }"
      @close="closeDialog"
    >
      <div class="h-full">
        <div class="flex mb-10px mr-10px">
          <span class="flex items-center">标题：</span>
          <el-input
            class="mr-10px w-200px"
            v-model="searchForm.title"
            placeholder="请输入"
            clearable
          ></el-input>
          <span class="flex items-center">应急预案：</span>
          <el-input
            class="mr-10px w-200px"
            v-model="searchForm.planName"
            placeholder="请输入"
            clearable
          ></el-input>
          <span class="flex items-center">状态：</span>
          <el-input
            class="mr-10px w-200px"
            v-model="searchForm.status"
            placeholder="请输入"
            clearable
          ></el-input>
          <el-button size="small" type="primary" @click="search()">搜索</el-button>
        </div>
        <div class="mt-10px h-[calc(100%-82px)]">
          <el-table :data="tableData" height="100%">
            <el-table-column label="标题" prop="title" show-overflow-tooltip></el-table-column>
            <el-table-column
              label="应急预案"
              prop="planName"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              label="应急类型"
              prop="planType"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              label="应急等级"
              prop="planLevel"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              label="启动人"
              prop="startUser"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              label="启动时间"
              prop="startTime"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column label="关闭人" prop="endUser" show-overflow-tooltip></el-table-column>
            <el-table-column
              label="关闭时间"
              prop="endTime"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column label="操作" align="center" show-overflow-tooltip width="120">
              <template slot-scope="scope">
                <span
                  class="text-blue-500 bold hover:text-blue-200 cursor-pointer mr-10px"
                  @click="viewDetail(scope.row)"
                  >查看</span
                >
                <span
                  class="text-blue-500 bold hover:text-blue-200 cursor-pointer"
                  @click="viewRoute(scope.row)"
                  >路线</span
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="text-center">
            <el-pagination
              @current-change="handlePageChange"
              :current-page="currentPage"
              background
              :page-size="pageSize"
              layout="total, prev, pager, next"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </CockpitDialog>
    <!-- 路线 -->
    <div class="absolute left-90px bottom-0 w-347px h-278px z-999" v-if="mapShow">
      <div
        class="close-btn absolute top-5px right-[-20px] w-20px h-20px cursor-pointer"
        @click="mapShow = false"
      ></div>
      <canvas id="dyw-escape-map-canvas" width="347" height="278" class="rounded-10px" :key="randomKey"></canvas>
    </div>
  </div>
</template>

<script>
import CockpitDialog from '@/components/cockpit/CockpitDialog'
import { EvacuatePathApi } from '@wiz-api/emergency-management'

const evacuatePathApi = new EvacuatePathApi()
const baseUrl = Wiz.GetModuleServer()
export default {
  components: {
    CockpitDialog,
  },
  props: {
    collapsePanel: {
      type: Boolean,
      default: false,
    },
    // 云渲染实例
    player: {
      type: Object,
      defalut: null,
    },
    cloudRender: {
      type: Object,
      defalut: null,
    },
  },
  data() {
    return {
      pageSize: 9999,
      currentPage: 1,
      total: 0,
      tableData: [],
      searchForm: {
        title: '',
        planName: '',
        status: '',
      },
      dywMap: require('../../../assets/images/dyw_map.png'),
      mapShow: false,
      randomKey: 0.5,
      evacutePaths: [], // 路线(多个)
      // 暂定6种路径颜色
      colors: ['#FF0000', '#00FF00', '#0000FF', '#FFFF00', '#FF00FF', '#00FFFF']
    }
  },
  computed: {},
  created() {
    this.getTableData()
  },
  methods: {
    search() {
      this.currentPage = 1
      this.getTableData()
    },
    handlePageChange(newPage) {
      this.currentPage = newPage
    },
    async closeDialog() {
      await this.cloudRender.Route.clearRoute()
      this.$emit('close')
    },
    async getTableData() {
      axios({
        method: 'GET',
        url: `${baseUrl}/openapi/ecologynew/list/V1.0?token=portal_js&title=${this.searchForm.title}&plan=${this.searchForm.planName}&status=${this.searchForm.status}`,
        headers: {
          'Content-Type': 'application/json; charset=utf8',
        },
        responseType: 'json',
      })
        .then((res) => {
          this.tableData = res.data.data || []
          this.total = this.tableData.length
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 查看详情
    viewDetail(row) {
      this.$emit('openLeft', {
        toCom: { code: 'EmergencyResponseDetailLeft', origin: 'EmergencyDisposalDyw', name: `应急流程图-${row.planName}` },
        type: 'mainComponent',
        props: {
          row,
          baseUrl
        },
      })
      this.$emit('openRight', {
        toCom: { code: 'EmergencyResponseDetailRight', origin: 'EmergencyDisposalDyw', name: '应急管理信息' },
        type: 'mainComponent',
        props: {
          row,
          baseUrl,
          player: this.player,
          cloudRender: this.cloudRender,
        },
      })
      this.$emit('close')
    },
    // 查看路线
    async viewRoute(row) {
      this.randomKey = Math.random()
      await this.getEvacuatePath(row.id)
    },
    // 获取路线
    async getEvacuatePath(id) {
      const res = await axios({
        method: 'post',
        // 低代码才有全局变量ApiBase
        url: `${ApiBase}/api/FormEngine/getTableData`,
        data: {
          TableName: 'diy_plan_relation',
          _PageIndex: 1,
          _PageSize: 1,
          _SearchEqual: {
            planId: id,
          },
        },
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('authorization')}`,
        },
      })
      if (res.data && res.data.Code === 1 && res.data.Data && res.data.Data.length > 0) {
        this.mapShow = true
        const data = res.data.Data.map((item) => {
          return {
            ...item,
            relationPath: JSON.parse(item.relationPath),
          }
        })[0]
        if (Array.isArray(data.relationPath)) {
          this.evacutePaths = []
          for (let i = 0; i < data.relationPath.length; i += 1) {
            const item = data.relationPath[i]
            const [err1, res1] = await evacuatePathApi.get(item)
            if (err1) {
              console.log(err1)
              return
            }
            const path = JSON.parse(res1.coordinateJson).map((it) => {
              return { x: it.xIndex, y: it.yIndex, z: it.zIndex }
            })
            this.evacutePaths.push(path)
          }
          this.canvasMap(this.evacutePaths)
        }
      } else {
        this.$message.warning('没有路线数据')
      }
    },
    // canvas绘制地图
    canvasMap(pathArr) {
      const canvas = document.getElementById('dyw-escape-map-canvas')
      if (!canvas) return
      const ctx = canvas.getContext('2d')
      // 创建一个新的图像对象
      const img = new Image()
      img.src = this.dywMap
      // 当图像加载完成后进行绘制
      img.onload = async () => {
        ctx.clearRect(0, 0, canvas.width, canvas.height) // 清除画布
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height) // 绘制图片
        // 销毁之前3d上的路径
        // await this.cloudRender.Route.destroyRoute('routeId') // 单条
        await this.cloudRender.Route.clearRoute() // 全部
        pathArr.forEach((path, index) => {
          this.drawCanvas(canvas, ctx, path, index)
          this.drawPath(path, index)
        })
      }
    },
    /**
     * 绘制3d路径
     */
    // 创建空路径
    async createPath(point = [], index) {
      const style = {
        lineColor: this.colors[index < this.colors.length ? index : index % this.colors.length],
        lineWidth: 2,
        isLineStipple: true,
        factor: 10,
      }
      const param = {
        id: `routeId${index}`,
        point,
        style,
      }
      if (this.cloudRender.Route) {
        await this.cloudRender.Route.createRoute(param)
      }
    },
    async drawPath(path, index) {
      // 绘制路径
      const point = path.map((item) => {
        return [item.x, item.y, item.z]
      })
      // 销毁之前的路径，实现一次只画一条
      // await this.cloudRender.Route.destroyRoute('routeId')
      await this.createPath(point, index)
    },
    /**
     * 绘制canvas
     * @param {*} canvas 画布对象
     */
    drawCanvas(canvas, ctx, path, index) {
      // 绘制路径
      const escapeRoutes = path
      ctx.beginPath()
      const { beginX, beginY } = this.mapToCanvas(canvas.width, canvas.height, escapeRoutes[0].x, escapeRoutes[0].y)
      ctx.moveTo(beginX, beginY)
      for (let i = 1; i < escapeRoutes.length; i += 1) {
        const { canvasX, canvasY } = this.mapToCanvas(canvas.width, canvas.height, escapeRoutes[i].x, escapeRoutes[i].y)
        ctx.lineTo(canvasX, canvasY)
      }
      ctx.closePath()
      // 超过6种颜色则循环
      ctx.strokeStyle = this.colors[index < this.colors.length ? index : index % this.colors.length]
      ctx.stroke()
    },
    /**
     * 坐标转换
     * @param {*} canvasWidth 画布宽度
     * @param {*} canvasHeight 画布高度
     * @param {*} x 需要转换的x坐标
     * @param {*} y 需要转换的y坐标
     */
    mapToCanvas(canvasWidth, canvasHeight, x, y) {
      const actualMinX = -429.699223
      const actualMinY = -471.349257
      const actualMaxX = 181.779426
      const actualMaxY = 123.336228
      // 实际区域宽度 = 右上角x - 左下角x = 181.779426 - (-429.699223) = 611.478649
      const actualWidth = actualMaxX - actualMinX
      // 实际区域高度 = 右上角y - 左下角y = 123.336228 - (-471.349257) = 594.685485
      const actualHeight = actualMaxY - actualMinY

      const canvasX = ((x - actualMinX) / actualWidth) * canvasWidth
      const canvasY = canvasHeight - ((y - actualMinY) / actualHeight) * canvasHeight

      return { canvasX, canvasY }
    },
  },
}
</script>

<style lang="scss" scoped>
.close-btn {
  background-color: transparent;

  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 14px;
    height: 2px;
    background-color: white;
    transform: translate(-50%, -50%);
  }

  &::before {
    transform: translate(-50%, -50%) rotate(45deg);
  }

  &::after {
    transform: translate(-50%, -50%) rotate(-45deg);
  }
}
</style>
